import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingCompanyInformationListComponent } from './billing-company-information-list/billing-company-information-list.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { BillingCompanyInformationViewComponent } from './billing-company-information-view/billing-company-information-view.component';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { BillingCompanyInformationEditComponent } from './billing-company-information-edit/billing-company-information-edit.component';
import { FormsModule } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { BillingComponentsModule } from '../billing-components/billing-components.module';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiPageHeaderButtonGroupModule } from '@fi-shared/fi-page-header-button-group/fi-page-header-button-group.module';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ComponentsModule,
        UtilitiesModule,
        MatRadioModule,
        BillingComponentsModule,
        FiPageHeaderModule,
        FiPageHeaderButtonGroupModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
    ],
    declarations: [
        BillingCompanyInformationListComponent,
        BillingCompanyInformationViewComponent,
        BillingCompanyInformationEditComponent,
    ],
})
export class BillingCompanyInformationModule {}
